/* eslint-disable react/jsx-no-target-blank */
import React from 'react';

import { EmitMetric } from '../../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import CopyLinkBlue from '../../Images/Icons/CopyLinkBlue/CopyLinkBlue';
import FacebookIcon from '../../Images/Icons/FacebookIcon/FacebookIcon';
import LinkCopiedIcon from '../../Images/Icons/LinkCopiedIcon/LinkCopiedIcon';
import LinkedinIcon from '../../Images/Icons/LinkedinIcon/LinkedinIcon';
import { SHARE_DESTINATIONS } from '../ReactionBar/CommunityShareButton/CommunitySharePopup/consts';

export const getFaceBookUrl = (urlToShare) => {
    const base = 'https://www.facebook.com/sharer/sharer.php?u=';
    const article = encodeURIComponent(urlToShare);
    return `${base}${article}`;
};

export const getLinkedInUrl = (urlToShare) => {
    const base = 'https://www.linkedin.com/sharing/share-offsite/?url=';
    const article = encodeURIComponent(urlToShare);
    return `${base}${article}`;
};

const SocialShareBar = ({ hash, type, location }) => {
    const route = type === 'editorial-content' ? '/career-topics' : '';
    const urlToShare = `${process.env.NEXT_PUBLIC_FAIRYGODBOSSAPP}${route}/${hash}`;
    const [isActive, setIsActive] = React.useState(false);

    const handleOnClickMetricEmit = (event, service) => {
        EmitMetric({
            community_content_key: `${type}-${hash}`,
            community_content_location: location,
            share_destination: service,
            misc_event_type: 'social-bar-share',
            share: 1,
        });
    };

    const handleClick = async (e) => {
        if (!navigator?.clipboard) return;
        try {
            await navigator.clipboard.writeText(
                `${urlToShare}?utm_source=${SHARE_DESTINATIONS.CLICKED_LINK}&utm_medium=content-share`
            );
            setIsActive(true);
            setTimeout(() => setIsActive(false), 2000);
            handleOnClickMetricEmit(e, 'link');
        } catch (error) {
            console.warn(e);
        }
    };

    return (
        <div className="component-SocialShareBar">
            <style jsx>
                {`
                    .component-SocialShareBar {
                        display: flex;
                        align-items: center;
                        position: relative;
                    }
                    .share-btn {
                        margin-right: 5px;
                        padding: 5px;
                        display: inline-block;
                        line-height: 0;
                    }
                    .share-btn:hover {
                        transform: translateY(-4px);
                    }
                    .link-copied {
                        position: absolute;
                        right: -82px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 0px;
                    }
                    .copied-label {
                        font-family: "Open Sans";
                        font-size: 14px;
                        margin-left: 10px;
                    }
                `}
            </style>
            <a
                role="button"
                onClick={(e) => handleOnClickMetricEmit(e, 'linkedin')}
                href={getLinkedInUrl(urlToShare)}
                target="_blank"
                tabIndex="0"
                className="share-btn"
                style={{
                    backgroundColor: 'rgb(0, 119, 181)',
                }}
            >
                <LinkedinIcon />
            </a>
            <a
                target="_blank"
                onClick={(e) => handleOnClickMetricEmit(e, 'facebook')}
                href={getFaceBookUrl(urlToShare)}
                role="button"
                tabIndex="0"
                className="share-btn"
                style={{
                    backgroundColor: 'rgb(59, 89, 152)',
                }}
            >
                <FacebookIcon />
            </a>
            <div
                onClick={(e) => handleClick(e, 'link')}
                role="button"
                tabIndex="0"
                onKeyDown={() => null}
                className="share-btn"
                style={{
                    backgroundColor: 'rgb(23, 139, 244)',
                }}
            >
                {!isActive && <CopyLinkBlue />}
                {isActive && <LinkCopiedIcon />}
            </div>
        </div>
    );
};

SocialShareBar.displayName = 'SocialShareBar';

export default SocialShareBar;
